import {Icon, MCIcon} from 'mc/lib/icon';
import React from 'react';
import {TypUcel} from '../../enums';

export default ({typUcel}) => {
    const title = TypUcel.getCaption(typUcel);

    switch (typUcel) {
        case TypUcel.UZAVIRKA:
            return <Icon icon="circle-o" title={title}/>;

        case TypUcel.DZ:
            return <Icon icon="map-signs" title={title}/>;

        case TypUcel.ZUK:
            return <Icon icon="road" title={title}/>;

        case TypUcel.VRAKY:
            return <MCIcon icon="wreck" title={title}/>;

        case TypUcel.STAVBNICINNOST:
            return <MCIcon icon="shovel" title={title}/>;

        case TypUcel.PRIPOJENIKOMUNIKACE:
            return <MCIcon icon="pipe" title={title}/>;

        case TypUcel.VYJIMKY:
            return <MCIcon icon="zuk_exception" title={title}/>;

        case TypUcel.PARKOVACIMISTA:
            return <Icon icon="car" title={title}/>;

        default:
            return <div>{typUcel}</div>;
    }
};
